import { MDXLayout as Layout } from "@/shared/components/MDX/MDXLayout";
import { Alert } from "@/shared/components/MDX/MDXComponents";

# راهنمای دستورالعمل‌های کاری (SOP)

این بخش جهت نمایش دستورالعمل‌ها، مستندات آموزشی و استانداردهای عملیاتی (Standard Operating Procedures) برای ایستگاه‌های کاری و عملیات تولید طراحی شده است. 

## مشاهده دستورالعمل‌ها

<Alert variant="info">
دستورالعمل‌ها معمولاً بر اساس **عملیات در حال اجرا** در ایستگاه کاری شما فیلتر می‌شوند تا دقیقاً همان راهنمایی که برای کار فعلی نیاز دارید را مشاهده کنید.
</Alert>

۱. لیست دستورالعمل‌های اختصاص یافته به عملیات جاری به صورت کارت‌هایی نمایش داده می‌شود.
۲. هر دستورالعمل شامل یک عنوان (نظیر "راهنمای تنظیم فشار دستگاه" یا "نکات ایمنی") و متن کامل شرح کار است.
۳. در صورتی که نیاز به جزئیات بیشتری دارید، لطفاً دستورالعمل‌ها را با دقت مطالعه کنید تا از خطاهای تولید جلوگیری شود.

export default Layout;
